(function () {
  function normalize(text) {
    return String(text || '').toLowerCase().replace(/\s+/g, ' ').trim();
  }

  function normalizeSearchText(text) {
    return String(text || '')
      .toLowerCase()
      .replace(/&/g, ' and ')
      .replace(/[^a-z0-9]+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function tokenize(text) {
    var normalized = normalizeSearchText(text);
    return normalized ? normalized.split(' ') : [];
  }

  function uniqueTokens(tokens) {
    var map = {};
    var unique = [];

    tokens.forEach(function (token) {
      if (!token || map[token]) return;
      map[token] = true;
      unique.push(token);
    });

    return unique;
  }

  function escapeHtml(text) {
    return String(text || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function slugify(text) {
    return normalize(text)
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-|-$/g, '') || 'faq';
  }

  function toBoolean(value) {
    return value === true || value === 'true';
  }

  function initAceiiRichFaq(section) {
    if (!section || section.getAttribute('data-ready') === 'true') return;

    section.setAttribute('data-ready', 'true');

    var categoryWrap = section.querySelector('[data-faq-categories]');
    var categoryCount = section.querySelector('[data-faq-category-count]');
    var list = section.querySelector('[data-faq-list]');
    var empty = section.querySelector('[data-faq-empty]');
    var pagination = section.querySelector('[data-faq-pagination]');
    var searchInput = section.querySelector('[data-faq-search]');
    var clearSearch = section.querySelector('[data-faq-clear]');
    var activeLabel = section.querySelector('[data-faq-active-label]');
    var countText = section.querySelector('[data-faq-result-count]');
    var sourceItems = Array.prototype.slice.call(section.querySelectorAll('.arf-source-item'));
    var allLabel = section.getAttribute('data-all-label') || 'All FAQs';
    var perPage = parseInt(section.getAttribute('data-per-page'), 10) || 10;
    var allowMultipleOpen = toBoolean(section.getAttribute('data-allow-multiple'));
    var enableDeepLinks = toBoolean(section.getAttribute('data-enable-deep-links'));
    var defaultCategory = section.getAttribute('data-default-category') || 'all';
    var activeCategory = defaultCategory;
    var currentPage = 1;
    var allItems = [];
    var openIds = {};
    var searchTimer = null;
    var usedIds = {};

    function makeUniqueId(base, index) {
      var id = slugify(base);
      if (!usedIds[id]) {
        usedIds[id] = 1;
        return id;
      }

      usedIds[id] += 1;
      return id + '-' + index;
    }

    sourceItems.forEach(function (item, index) {
      var q = item.querySelector('h3');
      var answer = item.querySelector('.arf-source-answer');
      var categoryNode = item.closest('.arf-source-category');
      var category = (categoryNode && categoryNode.getAttribute('data-category')) || item.getAttribute('data-category') || 'General';
      var question = q ? q.textContent.trim() : '';
      var answerHtml = answer ? answer.innerHTML.trim() : '';
      var answerText = answer ? answer.textContent.trim() : '';
      var keywords = item.getAttribute('data-keywords') || '';
      var categoryTokens = uniqueTokens(tokenize(category));
      var questionTokens = uniqueTokens(tokenize(question));
      var answerTokens = uniqueTokens(tokenize(answerText));
      var keywordTokens = uniqueTokens(tokenize(keywords));
      var allTokens = uniqueTokens([].concat(categoryTokens, questionTokens, answerTokens, keywordTokens));

      if (!question || !answerHtml) return;

      allItems.push({
        id: makeUniqueId(item.getAttribute('data-faq-id') || question, index),
        order: index,
        category: category,
        question: question,
        answerHtml: answerHtml,
        answerText: answerText,
        keywords: keywords,
        categoryTokens: categoryTokens,
        questionTokens: questionTokens,
        answerTokens: answerTokens,
        keywordTokens: keywordTokens,
        allTokens: allTokens,
        categorySearch: normalizeSearchText(category),
        questionSearch: normalizeSearchText(question),
        answerSearch: normalizeSearchText(answerText),
        keywordSearch: normalizeSearchText(keywords)
      });
    });

    if (!allItems.length || !categoryWrap || !list || !pagination) return;

    function categoryExists(category) {
      return category === 'all' || allItems.some(function (item) {
        return item.category === category;
      });
    }

    if (!categoryExists(activeCategory)) activeCategory = 'all';

    function getQuery() {
      return normalize(searchInput ? searchInput.value : '');
    }

    function tokenMatchesToken(queryToken, itemToken) {
      if (!queryToken || !itemToken) return false;
      if (itemToken === queryToken) return true;
      if (queryToken.length <= 2) return false;

      return itemToken.indexOf(queryToken) === 0;
    }

    function tokenMatchesItem(queryToken, item) {
      return item.allTokens.some(function (itemToken) {
        return tokenMatchesToken(queryToken, itemToken);
      });
    }

    function scoreTokenInField(queryToken, tokens, exactScore, prefixScore) {
      var score = 0;

      tokens.forEach(function (itemToken) {
        if (itemToken === queryToken) {
          score = Math.max(score, exactScore);
        } else if (queryToken.length > 2 && itemToken.indexOf(queryToken) === 0) {
          score = Math.max(score, prefixScore);
        }
      });

      return score;
    }

    function scoreItem(item, queryTokens, queryText) {
      var score = 0;

      if (!queryTokens.length) return 0;

      queryTokens.forEach(function (queryToken) {
        score += scoreTokenInField(queryToken, item.questionTokens, 40, 24);
        score += scoreTokenInField(queryToken, item.keywordTokens, 34, 20);
        score += scoreTokenInField(queryToken, item.categoryTokens, 26, 16);
        score += scoreTokenInField(queryToken, item.answerTokens, 10, 5);
      });

      if (queryText && item.questionSearch.indexOf(queryText) !== -1) score += 28;
      if (queryText && item.categorySearch.indexOf(queryText) !== -1) score += 18;
      if (queryText && item.keywordSearch.indexOf(queryText) !== -1) score += 18;
      if (queryText && item.answerSearch.indexOf(queryText) !== -1) score += 6;

      return score;
    }

    function itemMatchesQuery(item, queryTokens) {
      if (!queryTokens.length) return true;

      return queryTokens.every(function (queryToken) {
        return tokenMatchesItem(queryToken, item);
      });
    }

    function getFilteredItems(ignoreCategory) {
      var query = getQuery();
      var queryText = normalizeSearchText(query);
      var queryTokens = tokenize(query);
      var filtered = allItems.filter(function (item) {
        var categoryMatch = ignoreCategory || activeCategory === 'all' || item.category === activeCategory;
        return categoryMatch && itemMatchesQuery(item, queryTokens);
      });

      if (!queryTokens.length) return filtered;

      return filtered.sort(function (first, second) {
        var scoreDiff = scoreItem(second, queryTokens, queryText) - scoreItem(first, queryTokens, queryText);
        return scoreDiff || first.order - second.order;
      });
    }

    function getCategories() {
      var queryTokens = tokenize(getQuery());
      var categoryOrder = [];
      var counts = {};

      allItems.forEach(function (item) {
        if (categoryOrder.indexOf(item.category) === -1) categoryOrder.push(item.category);
        if (itemMatchesQuery(item, queryTokens)) {
          counts[item.category] = (counts[item.category] || 0) + 1;
        }
      });

      var total = Object.keys(counts).reduce(function (sum, name) {
        return sum + counts[name];
      }, 0);

      return [{ name: allLabel, value: 'all', count: total }].concat(
        categoryOrder.map(function (name) {
          return { name: name, value: name, count: counts[name] || 0 };
        })
      );
    }

    function renderCategories() {
      var cats = getCategories();
      if (categoryCount) categoryCount.textContent = cats.length - 1;

      categoryWrap.innerHTML = cats.map(function (cat) {
        return '<button class="arf-cat-btn ' +
          (cat.value === activeCategory ? 'is-active' : '') +
          '" type="button" aria-pressed="' + (cat.value === activeCategory ? 'true' : 'false') +
          '" data-category="' + escapeHtml(cat.value) + '">' +
          '<span>' + escapeHtml(cat.name) + '</span>' +
          '<em>' + cat.count + '</em>' +
          '</button>';
      }).join('');

      categoryWrap.querySelectorAll('.arf-cat-btn').forEach(function (button) {
        button.addEventListener('click', function () {
          activeCategory = button.getAttribute('data-category') || 'all';
          currentPage = 1;
          openIds = {};
          render(false);
        });
      });
    }

    function setOpen(itemId, isOpen) {
      if (!allowMultipleOpen) openIds = {};
      if (isOpen) {
        openIds[itemId] = true;
      } else {
        delete openIds[itemId];
      }
    }

    function updateDeepLink(itemId) {
      if (!enableDeepLinks || !window.history || !itemId) return;

      var cleanUrl = window.location.href.split('#')[0];
      window.history.replaceState(null, '', cleanUrl + '#faq-' + itemId);
    }

    function syncAnswerHeights() {
      list.querySelectorAll('.arf-item').forEach(function (item) {
        var answer = item.querySelector('.arf-answer');
        if (!answer) return;

        answer.style.maxHeight = item.classList.contains('is-open') ? answer.scrollHeight + 'px' : '0px';
      });
    }

    function renderList(items) {
      var start = (currentPage - 1) * perPage;
      var pageItems = items.slice(start, start + perPage);

      list.innerHTML = pageItems.map(function (item) {
        var answerId = section.id + '-answer-' + item.id;
        var isOpen = !!openIds[item.id];

        return '<article class="arf-item' + (isOpen ? ' is-open' : '') + '" id="faq-' + escapeHtml(item.id) + '">' +
          '<button class="arf-question" type="button" data-faq-toggle="' + escapeHtml(item.id) +
          '" aria-expanded="' + (isOpen ? 'true' : 'false') + '" aria-controls="' + escapeHtml(answerId) + '">' +
          '<span class="arf-arrow">→</span>' +
          '<span>' + escapeHtml(item.question) + '</span>' +
          '</button>' +
          '<div class="arf-answer" id="' + escapeHtml(answerId) + '">' +
          '<div class="arf-answer-inner rte">' + item.answerHtml + '</div>' +
          '</div>' +
          '</article>';
      }).join('');

      list.querySelectorAll('[data-faq-toggle]').forEach(function (button) {
        button.addEventListener('click', function () {
          var itemId = button.getAttribute('data-faq-toggle');
          var item = button.closest('.arf-item');
          var isOpen = item && item.classList.contains('is-open');

          setOpen(itemId, !isOpen);
          updateDeepLink(itemId);
          renderList(getFilteredItems());
        });
      });

      syncAnswerHeights();
    }

    function getPageNumbers(totalPages, page) {
      var pages = [];
      var i;

      if (totalPages <= 7) {
        for (i = 1; i <= totalPages; i += 1) pages.push(i);
        return pages;
      }

      pages.push(1);
      if (page > 3) pages.push('...');

      for (i = Math.max(2, page - 1); i <= Math.min(totalPages - 1, page + 1); i += 1) {
        pages.push(i);
      }

      if (page < totalPages - 2) pages.push('...');
      pages.push(totalPages);

      return pages;
    }

    function renderPagination(items) {
      var totalPages = Math.max(1, Math.ceil(items.length / perPage));

      if (items.length <= perPage) {
        pagination.innerHTML = '';
        return;
      }

      var pages = getPageNumbers(totalPages, currentPage);
      var html = '<button class="arf-page-btn arf-page-prev" type="button" data-prev="true" ' +
        (currentPage <= 1 ? 'disabled' : '') + ' aria-label="Previous FAQ page">←</button>';

      pages.forEach(function (page) {
        if (page === '...') {
          html += '<span class="arf-page-dots">...</span>';
          return;
        }

        html += '<button class="arf-page-btn ' +
          (page === currentPage ? 'is-active' : '') +
          '" type="button" data-page="' + page + '" aria-label="FAQ page ' + page + '">' + page + '</button>';
      });

      html += '<button class="arf-page-btn arf-page-next" type="button" data-next="true" ' +
        (currentPage >= totalPages ? 'disabled' : '') + ' aria-label="Next FAQ page">→</button>';

      pagination.innerHTML = html;

      pagination.querySelectorAll('[data-page]').forEach(function (button) {
        button.addEventListener('click', function () {
          currentPage = parseInt(button.getAttribute('data-page'), 10) || 1;
          openIds = {};
          render(false);
        });
      });

      var prev = pagination.querySelector('[data-prev]');
      var next = pagination.querySelector('[data-next]');

      if (prev) {
        prev.addEventListener('click', function () {
          if (currentPage > 1) {
            currentPage -= 1;
            openIds = {};
            render(false);
          }
        });
      }

      if (next) {
        next.addEventListener('click', function () {
          var totalPages = Math.max(1, Math.ceil(getFilteredItems().length / perPage));
          if (currentPage < totalPages) {
            currentPage += 1;
            openIds = {};
            render(false);
          }
        });
      }
    }

    function updateLabels(filtered) {
      var query = getQuery();

      if (activeLabel) {
        activeLabel.textContent = activeCategory === 'all' ? allLabel : activeCategory;
      }

      if (!countText) return;

      if (query) {
        countText.textContent = filtered.length + ' result' + (filtered.length === 1 ? '' : 's') + ' found';
      } else if (activeCategory !== 'all') {
        countText.textContent = filtered.length + ' question' + (filtered.length === 1 ? '' : 's') + ' in this category';
      } else {
        countText.textContent = 'Showing ' + filtered.length + ' questions';
      }
    }

    function scrollToSection() {
      var top = section.getBoundingClientRect().top + window.pageYOffset - 96;
      window.scrollTo({ top: top, behavior: 'smooth' });
    }

    function render(shouldScroll) {
      var filtered = getFilteredItems();
      var totalPages = Math.max(1, Math.ceil(filtered.length / perPage));

      if (currentPage > totalPages) currentPage = totalPages;

      renderCategories();
      renderList(filtered);
      renderPagination(filtered);
      updateLabels(filtered);

      if (empty) empty.classList.toggle('is-visible', filtered.length === 0);
      if (list) list.style.display = filtered.length === 0 ? 'none' : 'block';
      if (clearSearch) clearSearch.hidden = !getQuery();

      if (shouldScroll === false) scrollToSection();
    }

    function openHashFaq() {
      if (!enableDeepLinks || !window.location.hash || window.location.hash.indexOf('#faq-') !== 0) return false;

      var itemId = window.location.hash.replace('#faq-', '');
      var index = allItems.findIndex(function (item) {
        return item.id === itemId;
      });

      if (index < 0) return false;

      var item = allItems[index];
      var filtered;
      var filteredIndex;
      activeCategory = item.category;
      currentPage = 1;
      openIds = {};
      openIds[item.id] = true;

      if (searchInput && getQuery()) {
        searchInput.value = '';
      }

      filtered = getFilteredItems();
      filteredIndex = filtered.findIndex(function (filteredItem) {
        return filteredItem.id === item.id;
      });
      currentPage = filteredIndex > -1 ? Math.floor(filteredIndex / perPage) + 1 : 1;

      return true;
    }

    if (searchInput) {
        searchInput.addEventListener('input', function () {
          window.clearTimeout(searchTimer);
          searchTimer = window.setTimeout(function () {
            currentPage = 1;
            openIds = {};
            if (getQuery()) activeCategory = 'all';
            render();
          }, 120);
        });
    }

    if (clearSearch && searchInput) {
      clearSearch.addEventListener('click', function () {
        searchInput.value = '';
        currentPage = 1;
        openIds = {};
        searchInput.focus();
        render();
      });
    }

    window.addEventListener('hashchange', function () {
      if (openHashFaq()) render(false);
    });

    openHashFaq();
    render();
  }

  function initAll(scope) {
    var root = scope || document;
    var sections = root.querySelectorAll('[data-aceii-rich-faq]');

    Array.prototype.forEach.call(sections, initAceiiRichFaq);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
